export const SubscriptionType = {
  PSPLUS: 'PSPLUS',
  PSNOW: 'PSNOW',
  EAACCESS: 'EAACCESS',
  LOYALTY: 'LOYALTY',
  GTA_PLUS: 'GTA_PLUS',
  UBISOFT_PLUS: 'UBISOFT_PLUS',
};

export const SubscriptionStatus = {
  LAPSED: 'LAPSED',
  NEVER: 'NEVER',
  NOT_ENROLLED: 'NOT_ENROLLED',
  SUBSCRIBED: 'SUBSCRIBED',
};

export const SubscriptionTier = {
  NONE: 'NONE',
  NO_LOYALTY_LEVEL: 'NO_LOYALTY_LEVEL',
};

export const SubscriptionDuration = {
  NONE: 'NONE',
};

export const emsSubStatusMap = {
  active: SubscriptionStatus.SUBSCRIBED,
  never: SubscriptionStatus.NEVER,
  lapsed: SubscriptionStatus.LAPSED,
};
